import { computed, ComputedRef, toRef, toValue } from 'vue';
import { useQueryV2 } from '@libs/use';
import {
  UnderlyingEndDateQuery,
  UnderlyingEndDatesRequest,
} from '@libs/api-reference';

import * as API from '../requests';
import { OPTION_QUERY_KEYS } from '../constants';

interface getUnderlyingAssetIsinEndDatesParams {
  underlyingInstrumentIsin: ComputedRef<string> | string;
  immediate?: ComputedRef<boolean> | boolean;
}

export default function useUnderlyingAssetIsinEndDates({
  underlyingInstrumentIsin,
  immediate = false,
}: getUnderlyingAssetIsinEndDatesParams) {
  const {
    result,
    status: getUnderlyingAssetIsinEndDatesStatus,
    execute: getUnderlyingAssetIsinEndDates,
    isPending: isLoadingUnderlyingAssetIsinEndDates,
    isSuccess: isSuccessLoadingUnderlyingAssetIsinEndDates,
    isError: isErrorLoadingUnderlyingAssetIsinEndDates,
    isRevalidating: isRevalidatingUnderlyingAssetIsinEndDates,
  } = useQueryV2<UnderlyingEndDateQuery>(
    () =>
      API.getUnderlyingEndDates({
        underlyingInstrumentIsin: toValue(underlyingInstrumentIsin),
      }),
    {
      key: OPTION_QUERY_KEYS.underlyingAssetIsinEndDates(
        toRef({ underlyingInstrumentIsin })
      ),
      immediate,
      cacheTime: 1000 * 60, // 1m
      staleTime: 1000 * 60, // 1m
    }
  );

  const underlyingAssetIsinEndDates = computed(() => result.value?.data);

  return {
    underlyingAssetIsinEndDates,
    getUnderlyingAssetIsinEndDatesStatus,
    getUnderlyingAssetIsinEndDates,
    isLoadingUnderlyingAssetIsinEndDates,
    isSuccessLoadingUnderlyingAssetIsinEndDates,
    isErrorLoadingUnderlyingAssetIsinEndDates,
    isRevalidatingUnderlyingAssetIsinEndDates,
  };
}
